'use client';

import Image from '@/components/Image';
import { EProductImageType } from '@/utils/enums/goods';
import { useState } from 'react';

interface MarketingProductHoverMediaProps {
  image?: string;
  hoverImage?: string;
  hoverImageType?: EProductImageType;
  hoverImageIsGray?: boolean;
  imageAlt: string;
  imageSizes: string;
  mainImageBoxClassName: string;
  hoverProductImageBoxClassName: string;
}

export function MarketingProductHoverMedia({
  image,
  hoverImage,
  hoverImageType,
  hoverImageIsGray = false,
  imageAlt,
  imageSizes,
  mainImageBoxClassName,
  hoverProductImageBoxClassName,
}: MarketingProductHoverMediaProps) {
  const [loadedHoverImageSrc, setLoadedHoverImageSrc] = useState('');
  const isHoverImageReady = Boolean(hoverImage) && loadedHoverImageSrc === hoverImage;
  const isHoverProductImage = hoverImageType === EProductImageType.PRODUCT;

  return (
    <>
      <div className={mainImageBoxClassName}>
        {image && (
          <Image
            src={image}
            alt={imageAlt}
            fill
            sizes={imageSizes}
            className={`${isHoverImageReady ? 'group-hover/marketing-product-image:opacity-0' : ''} object-contain`}
          />
        )}
      </div>
      {hoverImage && (
        <div
          className={`pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden bg-white opacity-0 ${
            isHoverImageReady ? 'group-hover/marketing-product-image:opacity-100' : ''
          }`}
          data-marketing-hover-layer
        >
          {isHoverProductImage ? (
            <div className={hoverProductImageBoxClassName}>
              <Image
                key={hoverImage}
                src={hoverImage}
                alt={imageAlt}
                fill
                sizes={imageSizes}
                className={`object-contain ${hoverImageIsGray ? '' : 'mix-blend-multiply'}`}
                onLoad={() => setLoadedHoverImageSrc(hoverImage)}
                onError={() => setLoadedHoverImageSrc('')}
              />
            </div>
          ) : (
            <Image
              key={hoverImage}
              src={hoverImage}
              alt={imageAlt}
              fill
              sizes={imageSizes}
              className="object-cover"
              onLoad={() => setLoadedHoverImageSrc(hoverImage)}
              onError={() => setLoadedHoverImageSrc('')}
            />
          )}
        </div>
      )}
    </>
  );
}
